module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('a', {
    staticClass: "btn-link toggle-sidebar d-lg-none pg-icon btn-icon-link",
    attrs: {
      "href": "#",
      "data-toggle": "sidebar"
    }
  }, [_vm._v("\n          menu")]), _vm._v(" "), _c('div', {
    staticClass: "in_mobile"
  }, [_c('div', {
    staticClass: "brand inline d-none d-lg-block d-xl-block"
  }, [(_vm.company_logo) ? _c('img', {
    staticClass: "logo_c",
    staticStyle: {
      "height": "60px"
    },
    attrs: {
      "src": _vm.company_logo,
      "alt": "logo",
      "data-src": _vm.company_logo,
      "data-src-retina": _vm.company_logo
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "dropdown pull-right d-lg-block d-none"
  }, [_c('button', {
    staticClass: "profile-dropdown-toggle logindetail_p",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false",
      "aria-label": "profile dropdown"
    }
  }, [_c('div', {
    staticClass: "logindetail"
  }, [_c('span', [_vm._v(_vm._s(_vm.user.company))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user.first_name) + " " + _vm._s(_vm.user.last_name))])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right profile-dropdown",
    attrs: {
      "role": "menu"
    }
  }, [_c('a', {
    staticClass: "pull-left",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.logoutUser()
      }
    }
  }, [_vm._v("Logout")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-divider"
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "theme_change  btn-icon-link",
    staticStyle: {
      "display": "none"
    }
  }, [_c('i', {
    staticClass: "fas fa-sun"
  }), _c('i', {
    staticClass: "far fa-moon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "thumbnail-wrapper d32 circular inline"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/img/user.svg",
      "alt": "",
      "data-src": "/static/assets/img/user.svg",
      "data-src-retina": "/static/assets/img/user.svg",
      "width": "32",
      "height": "32"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-745d1741!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/root/navbar.vue
// module id = 1030
// module chunks = 27